import { useEffect, useState } from "react";
import { FaCarSide, FaHelicopter, FaMotorcycle, FaTractor, FaTrailer, FaTruck } from "react-icons/fa";
import Core from "../Core";
import { toast } from "react-toastify";
import { DefaultMessage } from "../../utils/defaultMessages";
import { ProductCardsSelector } from "../../components/ProductCardsSelector";
import Table from "../../components/Table";
import Pagination from "../Pricing/Pagination";
import DownloadXLSX from "../../utils/DownloadXLSX/DownloadXLSX";
import { useAuth } from "../../hooks/useAuth";
import { api } from "../../services/api";
import { FormProvider, useForm } from "react-hook-form";
import { formatDateTime } from "../../utils/FormatDateTime/FormatDateTime";
import DateRangeFilter from "../../components/DateRangeFilter";
import useWindowSize from "../../hooks/useWindowSize";
import { IoMdClose } from "react-icons/io";
import { FaCircleCheck } from "react-icons/fa6";
import { AnimatePresence, motion } from 'framer-motion';
import CustomSelect from "../../components/CustomSelect";

interface TableRowData {
    user: string
    product: string
    date: string
}

export default function TableFull() {
    const [selected, setSelected] = useState<string | null>(null);
    const [tableData, setTableData] = useState<TableRowData[]>();
    const colheitadeira = require("../../images/colheitadeira.png");
    const colheitadeiraBranca = require("../../images/colheitadeiraBranca.png");
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [totalPages, setTotalPages] = useState<number>(1);
    const [isClosing, setIsClosing] = useState(false);
    const [loading, setLoading] = useState(false);
    const [selectedProductLabel, setSelectedProductLabel] = useState<string | null>(null);
    // const [reloadListTable, setReloadListTable] = useState<boolean>(false);
    const { user } = useAuth()
    const { width } = useWindowSize()
    const today = new Date();
    const tenDaysAgo = new Date();
    tenDaysAgo.setDate(today.getDate() - 10);
    const [monthsOptions, setMonthsOptions] = useState<{ id: string, label: string, month: string, year: string, isDefault: boolean }[]>([]);
    const [selectedMonth, setSelectedMonth] = useState<string>('none');
    const [selectedYear, setSelectedYear] = useState<string>('none');
    const [selectedMontYear, setSelectedMontYear] = useState<string>('none');

    const monthNames = [
        "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
        "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
    ];
    const todayDate = today.toISOString().split('T')[0];
    const tenDaysAgoDate = tenDaysAgo.toISOString().split('T')[0];

    const methods = useForm({
        defaultValues: {
            start_date: tenDaysAgoDate,
            end_date: todayDate,
        },
    });

    const onSubmit = (data: any) => {
        setLoading(true)
        setCurrentPage(1)
        localStorage.setItem('filterDatesTableFull', JSON.stringify(data));
        handleChangeSearch(data, 1)
    };

    const columns = [
        { Header: 'Empresa', accessor: 'company_fantasy_name', Cell: ({ value }: any) => (value === null ? '-' : value), },
        { Header: 'Usuário', accessor: 'created_by_user_email', Cell: ({ value }: any) => (value === null ? '-' : value), },
        { Header: 'Produto', accessor: 'product', Cell: ({ value }: any) => (value === null ? '-' : value), },
        { Header: 'Solicitado em', accessor: 'created_at', Cell: ({ value }: any) => (value === null ? '-' : formatDateTime(value)), },
        {
            Header: 'Sucesso no download?',
            Cell: ({ row }: any) => {
                const { success, error_message } = row;

                if (success === true) {
                    return <span className="text-green-400 font-semibold text-center flex justify-center"><FaCircleCheck /></span>;
                }

                if (error_message) {
                    return <span className="text-red-500 text-center flex justify-center items-center">{error_message}</span>;
                }

                return '-';
            }

        },
    ];

    const products = [
        { id: "1", name: 'tractor', label: 'Trator', icon: <FaTractor /> },
        { id: "2", name: 'helicopter', label: 'Helicóptero', icon: <FaHelicopter /> },
        { id: "3", name: 'semitrailer', label: 'Semirreboque', icon: <FaTrailer /> },
        { id: "4", name: 'bodywork', label: 'Carroceria', icon: <FaTruck /> },
        {
            id: "6", name: 'harvester', label: 'Colheitadeira',
            icon: (
                <img
                    src={selected === "6" ? colheitadeiraBranca : colheitadeira}
                    alt="harvester"
                    className="w-6 h-6"
                />
            ),
        },
        {
            id: "7", name: 'leves', label: 'Leves (0Km)',
            icon: <><FaMotorcycle /><FaCarSide/></>,
        },
    ];

    useEffect(() => {
        handleChangeSearch()
        localStorage.clear()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handleChangeSearch = async (filters: any = {}, page: number = 1) => {
        try {
            const today = new Date();
            const tenDaysAgo = new Date();
            tenDaysAgo.setDate(today.getDate() - 10);

            const start_date = filters.start_date || tenDaysAgo.toISOString().split('T')[0];
            const end_date = filters.end_date || today.toISOString().split('T')[0];

            const response = await api.get(`/table/list/download/xlsx/client`, {
                params: {
                    start_date,
                    end_date,
                    page: page,
                    page_size: 10,
                },
            });

            setTableData(response.data?.content.results || []);
            setTotalPages(response.data?.content.pages || 1);
        } catch (error) {
            toast.error(DefaultMessage.ERROR, {
                position: toast.POSITION.TOP_RIGHT,
            });
        }
        setTimeout(() => {
            setLoading(false)
        }, 500)
    };

    const handleSelect = (id: string) => {
        if (selected === id) {
            setIsClosing(true);
            setTimeout(() => {
                setSelected(null);
                setSelectedProductLabel(null);
                setIsClosing(false);
                setSelectedMonth('none')
                setSelectedYear('none')
            }, 500);
        } else {
            setIsClosing(true);
            setTimeout(() => {
                const selectedItem = products.find(product => product.id === id);
                setSelected(id);
                setSelectedProductLabel(selectedItem?.label || null);
                setIsClosing(false);
                setSelectedMonth('none')
                setSelectedYear('none')
            }, 500);
        }
    };

    const handlePageChange = (newPage: number) => {
        setCurrentPage(newPage);
        const savedFiltersRaw = localStorage.getItem('filterDatesTableFull');
        if (savedFiltersRaw) {
            const savedFilters = savedFiltersRaw ? JSON.parse(savedFiltersRaw) : null;
            handleChangeSearch(savedFilters, newPage)
        } else {
            handleChangeSearch(undefined, newPage)
        }
    };

    const onClickDownload = async () => {
        try {
            const now = new Date();
            const dateStr = now.toLocaleDateString('pt-BR').replace(/\//g, '-');
            const timeStr = now
                .toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit', second: '2-digit' })
                .replace(/:/g, '-');

            const productName = selectedProductLabel || 'produto';
            const filename = `${productName}_data:${dateStr}_hora:${timeStr}.xlsx`;

            const url = `/table/download/xlsx/client/${selected}/?year_reference=${selectedYear}&month_reference=${selectedMonth}`;

            DownloadXLSX(url, filename);
        } catch (error) {
            toast.error(DefaultMessage.ERROR, {
                position: toast.POSITION.TOP_RIGHT,
            });
        }

        const savedFiltersRaw = localStorage.getItem('filterDatesTableFull');
        const savedFilters = savedFiltersRaw ? JSON.parse(savedFiltersRaw) : undefined;
        await handleChangeSearch(savedFilters);
    };

    const fetchReferences = async (url: string, type: 'months' | 'years') => {
        try {
            const response = await api.get(url);
            const refs = response.data.results || [];

            const mappedOptions = refs.map((item: any, index: number) => ({
                id: `${monthNames[item.month_reference - 1]}/${item.year_reference}`,
                label: `${monthNames[item.month_reference - 1]}/${item.year_reference}`,
                month: item.month_reference,
                year: item.year_reference,
                isDefault: index === 0,
            }));

            setMonthsOptions(mappedOptions);

            if (mappedOptions.length > 0) {
                const defaultOption = mappedOptions[0];
                setSelectedMontYear(defaultOption.id);
                setSelectedYear(defaultOption.year)
                setSelectedMonth(defaultOption.month)
            }
        } catch {
            toast.error(`Erro ao carregar ${type === 'months' ? 'meses' : 'anos'} de referência`);
        }
    };

    useEffect(() => {
        if (selected) {
            fetchReferences(`/table/list/references/table-full/${selected}`, 'months');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selected]);

    const handleChangeMonth = async (event: any) => {
        const selectedId = event.target.value;
        const selectedOption = monthsOptions.find(opt => opt.id === selectedId);
        if (!selectedOption) return;

        setSelectedMontYear(selectedOption.id)
        setSelectedYear(selectedOption.year)
        setSelectedMonth(selectedOption.month)

    };

    return (
        <Core withBlueBar withNavbar >
            <div className=" relative w-full items-center flex flex-col justify-center mb-8">
                <div
                    className="fixed z-50 w-full flex justify-center"
                    style={{ top: width > 900 ? '6.5rem' : '9.5rem' }}
                >
                    <ProductCardsSelector
                        products={products.filter(p => user?.products?.includes(p.id))}
                        selected={selected ? [selected] : []}
                        onSelect={handleSelect}
                    />

                </div>
                <motion.div
                    className=" transition-all duration-500 w-[90%] md:w-[50rem]"
                // layout
                >
                    {selected === null || selected === '' ? (
                        // <div className="flex justify-center items-center h-32">
                        //     <div className="w-8 h-8 border-4 border-[#00AEEF] border-t-transparent rounded-full animate-spin"></div>
                        // </div>
                        <motion.div
                            initial={{ opacity: 0, y: -20 }}
                            animate={{
                                opacity: isClosing ? 0 : 1,
                                y: isClosing ? -20 : 0,
                                zIndex: isClosing ? -1 : 0,
                            }}
                            transition={{ duration: 0.5 }}
                            className="mt-6 p-4 rounded-xl shadow bg-white text-center max-w-xl md:max-w-3xl mx-auto">
                            <h2 className="text-lg font-semibold mb-2">
                                Selecione um produto para download.
                            </h2>
                        </motion.div>
                    ) : (
                        <motion.div
                            initial={{ opacity: 0, y: -20 }}
                            animate={{
                                opacity: isClosing ? 0 : 1,
                                y: isClosing ? -20 : 0,
                                zIndex: isClosing ? -1 : 0,
                            }}
                            transition={{ duration: 0.5 }}
                            className="mt-6 p-4 rounded-xl shadow bg-white text-center max-w-xl md:max-w-3xl mx-auto">
                            <span data-testid='closed' className=" flex justify-end hover:cursor-pointer" onClick={() => { handleSelect('') }}><IoMdClose size={20} /></span>
                            <h2 className="text-lg font-semibold mb-2">
                                Produto selecionado: {selectedProductLabel}
                            </h2>
                            <div className="flex flex-col md:flex-row justify-center items-end gap-2 mb-4">
                                <CustomSelect
                                    widthProp='100%'
                                    name="month_reference"
                                    value={selectedMontYear}
                                    onChange={(newValue) => handleChangeMonth(newValue)}
                                    options={[
                                        { id: 'none', label: 'SELECIONE UM MÊS/ANO DE REFERÊNCIA' },
                                        ...monthsOptions,
                                    ]}
                                    multiple={false}
                                    showAllOption={false}
                                />
                            </div>

                            <button
                                className={`w-full md:w-[10rem] h-11 rounded-full px-4 py-1 text-white transition-all duration-500 
    ${selectedMontYear !== 'none'
                                        ? "bg-[#00AEEF] hover:bg-[#006991] cursor-pointer"
                                        : "bg-gray-400 cursor-not-allowed"
                                    }`}
                                type="button"
                                disabled={selectedMontYear === 'none'}
                                onClick={onClickDownload}
                            >
                                Baixar
                            </button>
                        </motion.div>
                    )}
                </motion.div>
                <div className="w-[90%] flex flex-col justify-center items-center md:w-full">
                    <div className="md:w-[55rem]">
                        <FormProvider {...methods}>
                            <form onSubmit={methods.handleSubmit(onSubmit)} className="pt-8 w-full flex flex-col md:gap-4 md:flex-row md:justify-center md:items-center">
                                <DateRangeFilter todayDate={new Date().toISOString().split('T')[0]} />
                                <button className="w-full md:w-[10rem] bg-[#00AEEF] h-11 rounded-full px-4 py-1 text-white hover:bg-[#006991] transition-all duration-500"
                                    type="submit"
                                >
                                    Filtrar
                                </button>
                            </form>
                        </FormProvider>

                    </div>
                    <AnimatePresence mode="wait">
                        {loading ? (
                            <motion.div
                                key="loading"
                                initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: 10 }} transition={{ duration: 0.4 }} className="flex justify-center items-center min-h-[150px]"
                            >
                                <div className="w-8 h-8 border-4 border-[#00AEEF] border-t-transparent rounded-full animate-spin" />
                            </motion.div>
                        ) : (
                            <motion.div
                                key="table"
                                initial={{ opacity: 0, y: -10 }}
                                animate={{ opacity: 1, y: 0 }}
                                exit={{ opacity: 0, y: 10 }}
                                transition={{ duration: 0.4 }}
                                className="w-[90%] md:w-full md:px-16 xl:px-[7rem] xl:w-full"
                            >
                                <Table
                                    columns={columns}
                                    data={tableData}
                                />
                                <Pagination
                                    currentPage={currentPage}
                                    totalPages={totalPages}
                                    onPageChange={handlePageChange}
                                />
                            </motion.div>
                        )}
                    </AnimatePresence>
                </div>
            </div>
        </Core>
    );
}